import React from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Chip, Stack, Tab, Tabs, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";
import OwnerWorkspaceNavigation from "./components/OwnerWorkspaceNavigation";
import OwnerFinanceHistoricalView from "./stats/OwnerFinanceHistoricalView";
import OwnerFinanceFutureView from "./stats/OwnerFinanceFutureView";

export default function OwnerStatisticsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get("vista") === "futuro" ? "future" : "history";
  const setView = (next) => {
    const params = new URLSearchParams(searchParams);
    if (next === "future") params.set("vista", "futuro");
    else params.set("vista", "historico");
    setSearchParams(params, { replace: true });
  };

  return (
    <Box sx={{ pb: 5, maxWidth: 1740, mx: "auto" }}>
      <OwnerWorkspaceNavigation />

      <Stack direction={{ xs: "column", lg: "row" }} justifyContent="space-between" spacing={1.4} alignItems={{ lg: "flex-end" }} sx={{ mb: 1.6 }}>
        <Box>
          <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
            <Typography variant="h4" sx={{ fontWeight: 1000, letterSpacing: "-.045em" }}>Estadísticas</Typography>
            <Chip size="small" label="OWNER" sx={{ fontWeight: 950 }} />
          </Stack>
          <Typography sx={{ mt: .45, color: "text.secondary", fontWeight: 700, maxWidth: 920 }}>
            Leé trayectoria, comportamiento y tendencia sin mezclar monedas ni contar transferencias internas como actividad económica.
          </Typography>
        </Box>
      </Stack>

      <Box sx={{ borderBottom: "1px solid", borderColor: "divider", mb: 1.5 }}>
        <Tabs value="finance" sx={{ minHeight: 46, "& .MuiTab-root": { minHeight: 46, textTransform: "none", fontWeight: 900 } }}>
          <Tab value="finance" icon={<AccountBalanceWalletRoundedIcon fontSize="small" />} iconPosition="start" label="Estadísticas financieras" />
        </Tabs>
      </Box>

      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1.2} sx={{ mb: 1.5 }}>
        <ToggleButtonGroup exclusive size="small" value={view} onChange={(_, next) => next && setView(next)} sx={{ "& .MuiToggleButton-root": { px: 1.7, textTransform: "none", fontWeight: 900 } }}>
          <ToggleButton value="history">Histórico</ToggleButton>
          <ToggleButton value="future">Futuro / Metas</ToggleButton>
        </ToggleButtonGroup>
        <Typography sx={{ display: { xs: "none", md: "block" }, color: "text.secondary", fontSize: 12.5, fontWeight: 700 }}>
          Histórico = hechos · Futuro = hipótesis y objetivos
        </Typography>
      </Stack>

      {view === "history" ? <OwnerFinanceHistoricalView /> : <OwnerFinanceFutureView />}
    </Box>
  );
}
